export default __webpack_public_path__ + "static/media/uncheck-icon.dc2e8b08.svg";